import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Main from './components/Main';
import Privacy from './components/Privacy';
import AppList from './components/AppList';
// import AppAds from './components/AppAds';

const APPS = {
  muse: {
    name: 'Muse',
    route: '/muse'
  },
  urlalbum: {
    name: 'URLAlbum',
    route: '/urlalbum'
  },
  auscitizenship: {
    name: 'AU Citizenship',
    route: '/auscitizenship'
  },
  ramentimer: {
    name: 'RamenTimer',
    route: '/ramentimer'
  }
};

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<AppList apps={APPS} />} />
        {/* Map routes in separate arrays to ensure proper matching */}
        {Object.entries(APPS).map(([key, app]) => (
          <Route
            key={`${key}-main`}
            path={app.route}
            element={<Main appKey={key} />}
          />
        ))}
        {Object.entries(APPS).map(([key, app]) => (
          <Route
            key={`${key}-privacy`}
            path={app.route + '/privacy'}
            element={<Privacy appKey={key} />}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
